import { CONTAINER_CONST } from './Container.d';
import { Container } from './Container.style';
import type { ContainerProps } from './Container.d';

const ContainerBase = ({
  children,
  fluid = false,
  marginBottom = 'sp-6',
  marginTop = 'sp-6',
  size = 'default',
  horizontalAlign = 'left',
  dataTestid = CONTAINER_CONST.TEST_ID,
  ...props
}: ContainerProps) => (
  <Container
    data-fluid={fluid}
    data-margin-bottom={marginBottom}
    data-margin-top={marginTop}
    data-size={size}
    data-testid={dataTestid}
    data-horizontal-align={horizontalAlign}
    {...props}
  >
    {children}
  </Container>
);

export default ContainerBase;
